// Returns true if any live preview fields have been touched by the user,
// false otherwise
import { useProduct } from './useProduct';
import { type UseFormReturn } from 'react-hook-form';
import { PDPFields, useProductForm } from './useProductForm';
import { arraysHaveOverlap } from 'helpers/arrays';

export const useHasTouchedLivePreviewFields = (): boolean => {
  const { product } = useProduct();
  const { form } = useProductForm();

  const touchedFields = getTouchedFields(form);
  const livePreviewFields = product.livePreviewAttributes;

  return arraysHaveOverlap(livePreviewFields, touchedFields);
};

const getTouchedFields = (form: UseFormReturn<PDPFields>) =>
  Object.entries(form.formState.touchedFields)
    .filter(([key, value]) => value)
    .map(([key]) => key);
